module.exports = __webpack_public_path__ + "img/solve-question.3357935b.png";